var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccountTreeFilled = function SvgAccountTreeFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18 9H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 9v8m7-.154V15a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1.846M13.037 21h-2.074a.963.963 0 0 1-.963-.963v-2.074c0-.532.431-.963.963-.963h2.074c.532 0 .963.431.963.963v2.074a.963.963 0 0 1-.963.963Zm7 0h-2.074a.963.963 0 0 1-.963-.963v-2.074c0-.532.431-.963.963-.963h2.074c.532 0 .963.431.963.963v2.074a.963.963 0 0 1-.963.963Zm-14 0H3.963A.963.963 0 0 1 3 20.037v-2.074c0-.532.431-.963.963-.963h2.074c.532 0 .963.431.963.963v2.074a.963.963 0 0 1-.963.963Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccountTreeFilled);
export default ForwardRef;